import { Route } from './route';
import { alias, incomplete } from './config';
import { trigger } from '@acng/frontend-bounty';
// TODO add bounty for Object.create
// TODO change bounty trigger second parameter string optional,  triggers custom event with third parameter detail
// TODO diese sachens sollten von middlewares/parser übernommen werden
export class RootRoute extends Route {
    globals = Object.create(null);
    busy = false;
    constructor(...config) {
        super();
        alias('root')(this);
        incomplete(this);
        this.config(...config);
    }
    check(pathname) {
        let success = false;
        Route.lastIndex = 0;
        Route.lastIndexMax = 0;
        if (super.check(pathname)) {
            success = !!(pathname.length && Route.lastIndexMax == pathname.length);
        }
        if (!success) {
            trigger(this, 'unknown', { pathname });
            if (pathname) {
                DEBUG: this.VERBOSE && console.warn(`voyager/root check - fail pathname`, { pathname });
                trigger(this, 'fail', { pathname });
            }
            else {
                DEBUG: this.VERBOSE && console.info('voyager/root check - empty pathname');
                trigger(this, 'empty', { pathname });
            }
        }
        return success;
    }
    reload(pathname) {
        this.check(pathname);
        this.update();
    }
    // TODO promise für die busy/settled geschichte
    update() {
        this.busy = true;
        for (const key in this.globals) {
            delete this.globals[key];
        }
        const res = super.update(this.globals);
        if (typeof res == 'object' && typeof res.then == 'function') {
            res.then(all => {
                DEBUG: this.VERBOSE && console.debug('RootRoute update settled', all);
                this.busy = false;
                trigger(this, 'settled', { goneAsync: true });
            });
        }
        else {
            DEBUG: this.VERBOSE && console.debug('RootRoute update settled');
            this.busy = false;
            trigger(this, 'settled', { goneAsync: false });
        }
    }
}
/**
 * This is the global root route for the app.
 */
export const rootRoute = new RootRoute();
